import type { ApiResponse } from '../types';

const API_BASE = import.meta.env.VITE_API_URL || '';

export async function apiFetch<T>(
  path: string,
  options?: RequestInit
): Promise<ApiResponse<T>> {
  const token = localStorage.getItem('admin_token');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  try {
    const res = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers: { ...headers, ...((options?.headers as Record<string, string>) || {}) },
    });

    const data = await res.json();

    // 自動處理認證過期
    if (res.status === 401 || data?.error?.code === 'UNAUTHORIZED') {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
      return {
        success: false,
        error: { code: 'UNAUTHORIZED', message: '認證已過期，請重新登入' },
      };
    }

    if (!res.ok && !data.error) {
      return {
        success: false,
        error: { code: 'UNKNOWN', message: `請求失敗 (${res.status})` },
      };
    }

    return data;
  } catch (err) {
    return {
      success: false,
      error: { code: 'NETWORK_ERROR', message: '網絡連接失敗，請檢查網絡後重試' },
    };
  }
}

export function apiUpload(path: string, formData: FormData): Promise<ApiResponse<{ proofUrl: string }>> {
  const token = localStorage.getItem('admin_token');
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return fetch(`${API_BASE}${path}`, {
    method: 'POST',
    body: formData,
    headers,
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok && !data.error) {
      return { success: false, error: { code: 'UNKNOWN', message: `上傳失敗 (${res.status})` } };
    }
    return data;
  }).catch(() => ({
    success: false,
    error: { code: 'NETWORK_ERROR', message: '網絡連接失敗' },
  }));
}

export function apiUploadFile<T>(path: string, formData: FormData): Promise<ApiResponse<T>> {
  const token = localStorage.getItem('admin_token');
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return fetch(`${API_BASE}${path}`, {
    method: 'POST',
    body: formData,
    headers,
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok && !data.error) {
      return { success: false, error: { code: 'UNKNOWN', message: `上傳失敗 (${res.status})` } };
    }
    return data;
  }).catch(() => ({
    success: false,
    error: { code: 'NETWORK_ERROR', message: '網絡連接失敗' },
  }));
}
